
import React from 'react';
import { motion } from 'framer-motion';
import QRCode from 'react-qr-code';
import { formatQRCode } from '@/utils/qrCodeUtils';

interface QRCodeDisplayProps {
  qrValue: string;
}

const QRCodeDisplay: React.FC<QRCodeDisplayProps> = ({ qrValue }) => {
  // Process QR code data using the standardized formatQRCode utility for consistent display
  const normalizedQrValue = formatQRCode(qrValue);
  
  // Debug log to verify code format
  console.log(`Displaying QR with normalized value: ${normalizedQrValue}`);

  return (
    <motion.div 
      className="bg-white p-4 rounded-lg shadow-md"
      initial={{ scale: 0.9 }}
      animate={{ scale: 1 }}
      transition={{ delay: 0.2, duration: 0.3 }}
      whileHover={{ scale: 1.02, boxShadow: "0 10px 25px -5px rgba(59, 130, 246, 0.5)" }}
    >
      <QRCode
        size={280} // Standardized size for better scanning
        value={normalizedQrValue}
        viewBox={`0 0 280 280`}
        level="H" // High error correction level for better reliability
        fgColor="#000000" // Pure black for maximum contrast
        bgColor="#FFFFFF" // Pure white for maximum contrast
      />
    </motion.div>
  );
};

export default QRCodeDisplay;
